import { render, staticRenderFns } from "./OrthoBackLegPain.vue?vue&type=template&id=704a8dba&scoped=true"
import script from "./OrthoBackLegPain.vue?vue&type=script&lang=js"
export * from "./OrthoBackLegPain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704a8dba",
  null
  
)

export default component.exports